import React, { useEffect, useState, useCallback, /*Suspense*/ } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAccountlessPurchaseEmail } from '../actions/auth';
import { fetchSale, } from '../actions/sale';
import { PlanType } from '../reducers/models';
import currentSaleData from '../selectors/currentSaleData';
import currentUserInfo from '../selectors/currentUserInfo';
import { getItems } from '../selectors/selectCart';
import Log from '../utils/Log';
import { redirectToPlans } from '../utils/routes';
import { getPlanDiscountInfo } from '../utils/saleUtils';
//import { toast } from "react-toastify";
//import { downloadBuildboxClient } from '../utils/downloadsUtils';
import { beginStripeCheckoutSession } from '../actions/account';
import { loadStripe, Stripe } from '@stripe/stripe-js';
//import checkStylesForm from "../styles/CheckoutForm.module.scss";
import styles from "../styles/BillingFormStripeCheckout.module.scss";

import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import QueryString from "query-string";
import Loader from './Loader';
import { MorePaymentOptionsButton } from './MorePaymentOptionsButton';
// import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
// import GenericInput from './helpers/genericInput';
// import GenericModal from './helpers/GenericModal';
// import { validateEmail } from '../utils/validationForm';


export type Props = {
  history: string[];
};

export type PlanInfo = bb.model.ISubscription & {
  cartId: string;
};

export default function StripeCheckout(props: Props) {
  const currentUrl = new URL(window.location.href);
  const urlQuery = QueryString.parse(currentUrl.search);
  const parentSessionId = urlQuery["parentSessionId"] ? urlQuery["parentSessionId"] as string : null;

  const dispatch = useDispatch();
  const couponData = useSelector(currentSaleData);
  const currentUser = useSelector(currentUserInfo);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const selectedCartItems = useSelector(getItems)[0];

  //const { item, cartId } = selectedCartItems;
  const item = selectedCartItems ? selectedCartItems.item : undefined;
  const cartId = selectedCartItems ? selectedCartItems.cartId : undefined;

  const [, setPlanInfo] = useState<PlanInfo | null>(null);

  const [quantity, updateQuantity] = useState(1);
  const [stripePromise, setStripePromise] = useState<Promise<Stripe|null>|null>(null);

  const [xsollaAllowed, setXsollaAllowed] = useState<boolean>(true)

  // trying to remove this email popup thing
  // const [openEmailPrompt, setEmailPrompt] = useState<boolean>(false)
  // const [inputEmail, updateEmail] = useState<string>("");
  // const [errorText, updateErrorMessage] = useState<string>("");

  async function onLoad() {
    
    setIsLoading(true);
    try {
      if(!item || !cartId) {
        redirectToPlans(props, "", "", "");
        return
      }
            
      // debug sleep
      //await new Promise(resolve => setTimeout(resolve, 5000)); 
      await dispatch(fetchSale());
      dispatch(setAccountlessPurchaseEmail(undefined))

      // xsolla has a bug "error 3035" that prevents us from using it for subs with trials since change_plan fails
      if(item.trialDays > 0 && process.env.REACT_APP_DISABLE_XSOLLA_FOR_PLANS_WITH_TRIAL_PERIODS === "true") {
        setXsollaAllowed(false)
      }
      // if we're in the upsell flow we shouldn't allow switching back and forth
      if(parentSessionId) {
        setXsollaAllowed(false)
      }

      if (item.planType === PlanType.Free) {
        const promoCode = sessionStorage.getItem("promoCode");
        redirectToPlans(props, "", "", promoCode);
      }

      if (selectedCartItems.seatQuantity) {
        updateQuantity(selectedCartItems.seatQuantity);
      }

      setPlanInfo({ cartId, ...item });
      //downloadOnLoad(); // disabled due to user feedback

      const stripeProm = loadStripe(process.env.REACT_APP_STRIPE_KEY || "missing_stripe_key");
      setStripePromise(stripeProm);
      sessionStorage.setItem("lastPaymentProvider", "stripe");
      setIsLoading(false)
    } catch (error:any) {
      let message = error.message
      Log.error("Checkout Component: error caught on onLoad " + message);
      console.log("error caught on onLoad ", message)
      setIsLoading(false);
      setIsError(true);
      setErrorMessage(message);
    }
  }

  /*
  async function downloadOnLoad() {
    // if safari, don't download automatically, bad stuff happens for some reason and it starts saying "Network Error" to everything
    const isSafari = typeof (window as any).safari !== "undefined" && (window as any).safari?.pushNotification;
    if (isSafari) {
      console.log("safari")
      return;
    }

    const noDownload = urlQuery["nodl"] === "1";
    if(noDownload) {
      return;
    }

    async function attemptToDownload() {
      try {
        if (item.productType) {
          const response = await downloadBuildboxClient(null, item.productType);
          Log.info(
            "response from auto download on load after getting gcid",
            response
          );
          return response;
        } 
        else {
          console.log("not sure what to download; skipping")
          return null;
        }
      } 
      catch (e) {
        Log.error("attempt to download failed:", e);
      }
    }

    let result = await attemptToDownload();
    if(result) {
      toast.success("Downloading now!", {
        autoClose: 5000,
      });
    }
  }
    */


  const loadEmbeddedStripeCheckout = useCallback(async () => {
    try {
      if(!selectedCartItems.item || !couponData) {
        return null
      }

      const itemDiscountInfo = getPlanDiscountInfo(
        selectedCartItems.item,
        couponData
      );
      const response = await dispatch(beginStripeCheckoutSession(true, quantity, parentSessionId, itemDiscountInfo?.stripeCouponId, )) as any;
      return response.payload.client_secret;
    }
    catch (error:any) {
      console.error('Error:', error);
      setIsError(true);
      setIsLoading(false);
      if(error.message) {
        setErrorMessage(error.message);
      }
      else {
        setErrorMessage("An error occurred, please try again or contact support at support@buildbox.com.");
      }
    }
  }, [couponData, dispatch, quantity, selectedCartItems, parentSessionId]);

  useEffect(() => {
    onLoad(); //eslint-disable-next-line
  }, [currentUser]);

  /**
   * for handling switching to xsolla, including collecting an email for an accountless checkout,
   * which is something I could try to refactor out but is probably a lot of work so can't right now
   */
  const handleToXsollaCheckout = () => {
    window.location.href = `/purchaseThroughXsolla`

    // if (currentUser?.email){
    //   window.location.href = `/purchaseThroughXsolla?nodl=1`
    // } else {
    //   setEmailPrompt(true)
    // }
  }

  // const handleEmailPromptModalClose = () => {
  //   setEmailPrompt(false)
  // }

  // function handleEmailChange(inputName:string, value:string) {
  //   updateEmail(value);
  // }


  // const proceedToXsollaCheckout = () => {
  //   if(validateEmail(inputEmail)){
  //     dispatch(setAccountlessPurchaseEmail(inputEmail))
  //     window.location.href = `/purchaseThroughXsolla?nodl=1`
  //   } else {
  //     updateErrorMessage("Please enter a valid email.")
  //   }
  // }
  /**
   * end of handling switch-to-xsolla
   */  

  if(isLoading) {
    // this ALMOST looks good, but the logo has a weird black outline and the text/font size gets weird...
    // there's probably a better way than hardcoding these colors...
    return (
      <div className={styles.content}>
        <Loader backgroundColor="#f3f9f9" textColor="#333"/>
      </div>
    )

    // // here's my boring but functional one for the meantime
    // return (
    //   <div className={styles.content}>        
    //     <div className={styles.loadingContainer}>
    //       <p>Loading...</p>
    //     </div>
    //   </div>
    // )
  }

  if(isError) {
    return (
      <div className={styles.content}>
        <div className={styles.errorContainer}>
          <p>{errorMessage}</p>
        </div>
      </div>
    )
  }

  const CheckoutForm = () => {
    if(!stripePromise) {
      return null;
    }

    const options = {
      fetchClientSecret: loadEmbeddedStripeCheckout,
    };
  
    return (
      <div className={styles.embeddedCheckoutContainer}>
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={options}
        >
          <EmbeddedCheckout className={styles.checkout}/>
        </EmbeddedCheckoutProvider>
      </div>
    )
  }
  
  // these styles are just for the xsolla email popup thing
  // const modalStyle = {
  //   maxWidth: "500px",
  //   padding: "3rem",
  //   backgroundColor: "#fff",
  // };
  // const inputStyles = {
  //   container: checkStylesForm.paymentInputWrapper,
  //   label: checkStylesForm.paymentInputLabel,
  //   input: checkStylesForm.paymentInput,
  //   errorMessage: checkStylesForm.paymentErrorText,
  //   icon: checkStylesForm.inputIcon,
  // };  

  return (
    <div className={styles.content} id="content">
      {/* <Suspense fallback={<Loader />}> */}
      {/* <GenericModal
        isShowing={openEmailPrompt}
        hide={handleEmailPromptModalClose}
        hideClose={true}
        modalStyle={modalStyle}
        darkMode={false}
        modalHeaderStyle={undefined}
      > 
        <div className={checkStylesForm.payment}>
          <div className={styles.emailPrompt}>
            <h2>Please enter an email so we can setup your Buildbox account.</h2>
            <div style={{paddingBottom: "8px"}}/>
            <h2>Welcome to the family!</h2>
            <div style={{paddingBottom: "8px"}}/>
            <p>If you currently have a Buildbox account, you should enter that email here. Thank you!</p>
            <div style={{paddingBottom: "8px"}}/>
            <GenericInput
              type={"email"}
              title={"Email:"}
              placeholder={""}
              inputName={"email"}
              inputValue={inputEmail}
              changeCallback={handleEmailChange}
              errorMessage={errorText}
              styles={inputStyles}
              icon={faEnvelope}
            />
          </div>
          <div className={styles.buttonsSubmit}>
            <button
              onClick={() => { setEmailPrompt(false) }}
              className={ styles.darkCheckoutButton }
            >
              Close
            </button>
            <button
              disabled={validateEmail(inputEmail) ? false : true}
              className={ styles.checkoutButton }
              onClick={() => proceedToXsollaCheckout()}
            >
              Go To Checkout
            </button>
          </div>
      </div>
      </GenericModal> */}

      <CheckoutForm />
      { xsollaAllowed && <MorePaymentOptionsButton handleToXsollaCheckout={handleToXsollaCheckout} />}
      {/* </Suspense> */}
    </div>
  );    
};

